import React, { useEffect, useState } from 'react';
import axios from 'axios';
import ProductList from '../../components/DynamicListGrid/DynamicListGrid';
import {getStoredData} from "../../JsonFiles/fetchData";
import { useNavigate } from 'react-router-dom';

const AdminProducts = () => {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const totalData = getStoredData();
  const fields = totalData ? totalData["11"].AdminProducts : {};

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const response = await axios.get('https://shahbad-enterprises-backend.vercel.app/products');
        setProducts(response.data);
        setLoading(false);
      } catch (error) {
        console.error('Error fetching actvities:', error);
        setLoading(false);
      }
    };

    fetchProducts();
  }, []);

  if (loading) {
    return <p>Loading products...</p>;
  }

  return (
    <div className="admin-products">
      <h2>Products List</h2>
      <button onClick={() => navigate('/admin/add-products')}>
        Create New Products
      </button>
      <ProductList products={products} fields={fields} redirect={totalData[11].AdminProductsEdit} deleteApi="https://shahbad-enterprises-backend.vercel.app/products"/>
    </div>
  );
};

export default AdminProducts;

